<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("foodcategories", 2) }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-food-categories" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="onVendorSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="filterIsActive => getVendorsList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(fc, vendorkey) in ms_food_categories"
        :key="vendorkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ fc.fc_category }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/fnb/edit-food-categories', fc)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-food-categories', fc)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="fc.fc_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="fc.fc_is_active == 'Y' ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'fc_category'"
              @click="onSortValue('fc_category', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('fc_category', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('fc_category', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("foodcategory", 2) }}
          </th>
          <th>{{ $t("foodorder") }}</th>
          <th class="text-right">
            <span class="pr-5">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(fc, vendorkey) in ms_food_categories" :key="vendorkey">
          <td>{{ fc.fc_category }}</td>
          <td>{{ fc.fc_order }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="fc.fc_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot :status="fc.fc_is_active == 'Y' ? true : false" />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/fnb/edit-food-categories', fc)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-food-categories', fc)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import { BASEURL } from "@/config/index.js";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      gridView: false,
      listView: true,
      ms_food_categories: [],
      viewingnumbers: [],
      URL_BASE: BASEURL,
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "desc",
      columnName: "created_at",

      debounce: null,
      searchValue: "",
      searchKey: "fc_category"
    };
  },
  beforeMount() {
    this.getviewingnumber();
  },
  mounted() {
    this.getVendorsList();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getVendorsList();
      } else {
        this.currentPage = event;
        this.getVendorsList();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getVendorsList();
    },
    getVendorsList: function(filterIsActive = "Y") {
      this.ms_food_categories = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        searchKey: this.searchKey,
        filter_is_active: filterIsActive
      };
      PosFnbService.GetFoodCategories(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError);
    },
    goToRoute: function(path, { fc_id }) {
      console.log("fc_id :", fc_id);
      this.$router.push({
        path: path,
        query: {
          fc_id: fc_id
        }
      });
    },
    /* eslint-disable */

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    onVendorSearch: function() {
      this.getVendorsList();
    }
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/foodCategories.vue